// Vendor imports
const { combineReducers } = require('redux-immutable')
// Common imports
const commonReducers = require('client-v2/common/state/reducers')
// Entry imports
const RootRecord = require('client-v2/logged-out-landing/state/record')

const reducers = Object.assign({}, commonReducers, {
  // Common container reducers
  articleProfileModal: require('client-v2/common/containers/article-profile/state/modal-reducer'),
  authModal: require('client-v2/common/containers/auth-modal/reducer'),
  // Entry container reducers
  discover: require('client-v2/logged-out-landing/containers/discover/reducer'),
  featuredCollections: require('client-v2/logged-out-landing/containers/featured-collections/reducer'),
  topCallToAction: require('client-v2/logged-out-landing/containers/top-call-to-action/reducer')
})

module.exports = combineReducers(
  reducers,
  () => new RootRecord()
)
